import { combineReducers } from 'redux';

const initialState = {
  info: {
    money: null,
    waitMoney: null,
    income: null,
  },
  flow: {
    loadedAll: false,
    loadStatus: 0,
    list: null,
  },
  moneyExport: {
    saveStatus: 0 /* 0: unsave; 1: saving; 2: saved */,
    input: '',
    info: {
      maxExport: 0,
      taxRatio: 0,
      tokenMoney: 0,
      taxPayed: 0,
      tips: null,
      errorTips: null,
    },
  },
};

function infoReducer(state = initialState.info, action) {
  switch (action.type) {
    case 'LOAD_WALLET_INFO_COMPLETION': {
      if (action.error) {
        return state;
      }
      return {
        ...state,
        ...action.data,
      };
    }

    default:
      return state;
  }
}

function flowReducer(state = initialState.flow, action) {
  switch (action.type) {
    case 'LOAD_WALLET_FLOW_LIST': {
      return {
        ...state,
        loadStatus: 1,
      };
    }

    case 'LOAD_WALLET_FLOW_LIST_COMPLETION': {
      const { tool, list, range, error } = action;

      if (error) {
        return {
          ...state,
          loadStatus: 0,
        };
      }

      return {
        ...state,
        loadStatus: 2,
        tool,
        loadedAll: list.length < range.length,
        list: state.list
          ? state.list.slice(0, range.location).concat(list)
          : list,
      };
    }

    default:
      return state;
  }
}

function moneyExportReducer(state = initialState.moneyExport, action) {
  switch (action.type) {
    case 'RESET_MONEY_EXPORT': {
      return initialState.moneyExport;
    }

    case 'UPDATE_MONEY_EXPORT_INPUT': {
      return {
        ...state,
        input: action.input,
      };
    }

    case 'LOAD_MONEY_EXPORT_INFO_COMPLETION': {
      const { error, data } = action;

      if (error) {
        return state;
      }

      return {
        ...state,
        info: data,
      };
    }

    case 'EXPORT_MONEY': {
      return {
        ...state,
        saveStatus: 1,
      };
    }

    case 'EXPORT_MONEY_COMPLETION': {
      if (action.error) {
        return {
          ...state,
          saveStatus: 0,
        };
      }

      return {
        ...state,
        saveStatus: 2,
      };
    }

    default:
      return state;
  }
}

export default combineReducers({
  info: infoReducer,
  flow: flowReducer,
  moneyExport: moneyExportReducer,
});
